// API Configuration
// MUST be explicitly set in environment variables

const getApiBaseUrl = (): string => {
  const apiUrl = process.env.REACT_APP_API_URL;
  
  // Check if the environment variable is undefined (not set at all)
  if (apiUrl === undefined) {
    throw new Error(
      'REACT_APP_API_URL is not configured. ' +
      'Please set it in your .env file:\n' +
      '- For development: REACT_APP_API_URL=http://localhost:3001\n' +
      '- For production same-origin: REACT_APP_API_URL= (empty string)\n' +
      '- For production different domain: REACT_APP_API_URL=https://api.yourdomain.com'
    );
  }
  
  return apiUrl;
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URLs
export const buildApiUrl = (path: string): string => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export default API_BASE_URL;